import React, { PureComponent } from 'react'

import Colors from '../../../themes/Colors'

import { ResponsiveContainer } from '../styledComponents'
import SectionHeading from '../common/SectionHeading'
import EnquireNowButton from '../EnquireNowButton'

import Card from './card'
import {
  SectionContainer,
  SectionWrapper,
  CardsWrapper,
  ButtonWrapper
} from './styledComponents'

export default class PortfolioSection extends PureComponent {
  renderCards = cardsList => cardsList.map(card => <Card {...card} />)
  render() {
    const { portfolioSectionData, id, formData, glsLoaded } = this.props
    return (
      <SectionContainer id={id}>
        <ResponsiveContainer>
          <SectionWrapper>
            <SectionHeading
              sectionHeadingText="iB CRICKET BUZZ DURING 2019"
              color={Colors.oceanBlue}
            />
            <CardsWrapper>
              {this.renderCards(portfolioSectionData)}
            </CardsWrapper>
          </SectionWrapper>
          <ButtonWrapper>
            <EnquireNowButton
              id={'ibcricket-buzz-during-2019-enquire-button'}
              formData={formData}
              glsLoaded={glsLoaded}
              text="ENQUIRE NOW"
            />
          </ButtonWrapper>
        </ResponsiveContainer>
      </SectionContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/PortfolioSection/index.js